export default "__VITE_ASSET__DgJPq1a2__"